import React from "react";
import { Box, Typography } from "@mui/material";

const WebGpuFallback = ({ isPhone, title, summary, detail }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: isPhone ? 2 : 4,
        py: isPhone ? 3 : 5,
        overflow: "hidden",
        background:
          "radial-gradient(circle at top left, rgba(39, 94, 107, 0.45) 0%, rgba(9, 15, 23, 0) 38%), radial-gradient(circle at bottom right, rgba(16, 90, 82, 0.35) 0%, rgba(9, 15, 23, 0) 34%), linear-gradient(180deg, #060b10 0%, #0c141d 100%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(120, 236, 218, 0.08) 0%, rgba(120, 236, 218, 0) 24%, rgba(255, 255, 255, 0) 100%)",
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          position: "relative",
          width: "min(100%, 720px)",
          px: isPhone ? 2.5 : 4.5,
          py: isPhone ? 3 : 4.5,
          borderRadius: isPhone ? "20px" : "24px",
          color: "#f5fffd",
          background:
            "linear-gradient(180deg, rgba(11, 19, 28, 0.9) 0%, rgba(10, 16, 24, 0.78) 100%)",
          border: "1px solid rgba(132, 235, 220, 0.16)",
          boxShadow: "0 24px 60px rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(14px) saturate(120%)",
          WebkitBackdropFilter: "blur(14px) saturate(120%)",
          textAlign: "left",
        }}
      >
        <Typography
          variant="overline"
          sx={{
            display: "block",
            mb: 1,
            color: "rgba(161, 241, 224, 0.94)",
            letterSpacing: "0.16em",
          }}
        >
          Teacher support
        </Typography>

        <Typography
          variant="h4"
          sx={{
            fontSize: isPhone ? "1.45rem" : "2rem",
            lineHeight: 1.1,
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 1.5,
            color: "rgba(233, 245, 243, 0.9)",
            fontSize: isPhone ? "0.98rem" : "1.05rem",
            lineHeight: 1.6,
          }}
        >
          {summary}
        </Typography>

        <Box
          sx={{
            mt: 3,
            px: 2,
            py: 1.75,
            borderRadius: "16px",
            background:
              "linear-gradient(180deg, rgba(121, 223, 210, 0.12) 0%, rgba(121, 223, 210, 0.05) 100%)",
            border: "1px solid rgba(132, 235, 220, 0.14)",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "rgba(161, 241, 224, 0.9)",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
            }}
          >
            Need classroom support?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 0.75,
              color: "#f2fffc",
              fontSize: isPhone ? "0.98rem" : "1.02rem",
              lineHeight: 1.5,
              fontWeight: 600,
            }}
          >
            If you need updated classroom hardware, we are happy to help
            document requirements or support grant applications.
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            mt: 2.5,
            color: "rgba(214, 228, 225, 0.8)",
            lineHeight: 1.55,
          }}
        >
          Some older computers will not be able to run this experience.
        </Typography>

        {detail ? (
          <Box
            sx={{
              mt: 3,
              px: 1.5,
              py: 1.25,
              borderRadius: "14px",
              backgroundColor: "rgba(117, 219, 205, 0.08)",
              border: "1px solid rgba(117, 219, 205, 0.12)",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                display: "block",
                mb: 0.5,
                color: "rgba(161, 241, 224, 0.86)",
                letterSpacing: "0.12em",
              textTransform: "uppercase",
            }}
          >
              Details
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(229, 238, 236, 0.84)",
                wordBreak: "break-word",
              }}
            >
              {detail}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default WebGpuFallback;
